import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '@grandvisionhq/state';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import { ProductReimbursableLogoContainer } from '../components/ProductReimbursableLogo/ProductReimbursableLogoContainer.js';
import '@grandvisionhq/inventory';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { VariantSelectorTree } from '../components/VariantSelectorTree/VariantSelectorTree.js';
import { useEcommFacetContext } from '../context/EcommFacetContext.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { FramesBundleContentDescriptionContainer } from './components/FramesBundleContentDescription/FramesBundleContentDescriptionContainer.js';
import { FramesCTA } from './components/FramesCTA/FramesCTA.js';
import { FramesDeliveryIndicator } from './components/FramesDeliveryIndicator/FramesDeliveryIndicator.js';
import { useFramesEcommContext } from './context/FramesEcommContext.js';
import { FramesPriceSection } from './components/FramesPriceSection/FramesPriceSection.js';
import { FramesOfferingsList } from './components/FramesOfferingsList/FramesOfferingsList.js';

const FramesEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku  } ,  } = useProductData();
    const { handleConfiguratorClose , isConfiguratorOpen  } = useFramesEcommContext();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = ()=>setNotificationType('error')
    ;
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('frames-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductReimbursableLogoContainer, {
        className: "frames-ecomm-content__reimbursable-logo"
    }), /*#__PURE__*/ React.createElement(ProductTag, {
        className: "frames-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(FramesBundleContentDescriptionContainer, null), /*#__PURE__*/ React.createElement(FramesPriceSection, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(VariantSelectorTree, null), /*#__PURE__*/ React.createElement("div", {
        className: "frames-ecomm-content__column"
    }, /*#__PURE__*/ React.createElement(FramesOfferingsList, null), /*#__PURE__*/ React.createElement(FramesDeliveryIndicator, null), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(FramesCTA, null)), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }) : null), Slots.Configurator && /*#__PURE__*/ React.createElement(Slots.Configurator, {
        id: "glasses",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { FramesEcommContent };
//# sourceMappingURL=FramesEcommContent.js.map
